import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import { PublicDomainSetupInstructionsDto } from "../dto/PublicDomainSetupInstructionsDto";
import { PublicOrganizationNoticeDto } from "../dto/PublicOrganizationNoticeDto";

export class PublicOrganizationController {
  constructor(private axios: AxiosInstance) {}

  public getOrganizationNotices = async (organizationId) => {
    const url = Helpers.public.orgNotices(organizationId);
    const response = await this.axios.get<PublicOrganizationNoticeDto>(url, {});

    return response.data as PublicOrganizationNoticeDto;
  };

  public getDomainSetupInstructions = async (organizationId) => {
    const url = Helpers.public.orgDomainSetupInstructions(organizationId);
    const response = await this.axios.get<PublicDomainSetupInstructionsDto>(url, {});

    return response.data as PublicDomainSetupInstructionsDto;
  };
}
